module.exports = __webpack_public_path__ + "components/country-flag/static/mo-6c605aaea4417690eb78ad0889960f43.svg";